module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABKElEQVQ4T52Rr0tDYRiFn+OmCDOIIOi4F9a0mSxiFcSm7M5/QG2yogY1DAwGi4pFDBplE4yC1WCZ2aTpG/4AZSAijG2vuLmFcS8Ov/hxnvec97zin09RnBW8HJBQ4NbDNKGgnab6Gag9A33EP5KaL5c74XCw4C2BThpis1Vl3FEkaHliMDIEDEPvGWKyCXJPnQyVyiuPL+/KUf35bjha3r8DG0NK/NHVJ9iDAjfxC3pZpP3uCq5vKijttne0C28Z03ErRegQWVZpd9iO2hJZPrmIYucR0IrSrllY53TLj06j+E14ZJtT4K7CwYK/DexEOO4p7TYiHP1rxAzwhNka8EUPB5h8sFsFbirKsQgUidW3tFB6a5zqMjVIrZrDmFXgxkPB7s7RVH0Dia9gD9mdwL8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwu/service list_icon_score10.png
// module id = 0mWU
// module chunks = 1